<template>
  <div>
    <el-dialog
      title="累充最先抵达玩家"
      center
      :visible="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="true"
      :before-close="onClose"
      width="501px"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="150px"
        size="mini"
        style="width: 450px"
      >
        <el-form-item label="目标金额(单位：元): ">
          <el-input
            style="width: 100px"
            v-model="form.amount"
            clearable
          ></el-input>
          <el-button
            style="margin-left: 20px"
            type="primary"
            @click="queryTheFirstPlayerOfCostXYuan()"
            >查询</el-button
          >
        </el-form-item>
      </el-form>

      <div style="margin-left: 13px" v-if="this.entry">
        <el-descriptions :column="1" title="" style="width: 350px" border>
          <el-descriptions-item>
            <template slot="label"> UID </template>
            <a
              style="text-decoration: none"
              href="javascript:;"
              @click="toRouterPlayerInfoPage('uid', entry.uid)"
            >
              {{ this.entry.uid }}</a
            >
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> AID </template>
            <a
              style="text-decoration: none"
              href="javascript:;"
              @click="toRouterPlayerInfoPage('aid', entry.aid)"
            >
              {{ this.entry.aid }}</a
            >
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 昵称 </template>
            {{ this.entry.name }}
          </el-descriptions-item>

          <el-descriptions-item>
            <template slot="label"> 达到该金额的时间 </template>
            {{ ms2ymdhmss(this.entry.at) }}
          </el-descriptions-item>

          <el-descriptions-item>
            <template slot="label"> 达到该金额时的已累充金额 </template>
            {{ this.entry.theAmountOfRechargeAtThatTime }} 元
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const dialogutil = require("@/dialogutil");

// 本弹窗名称
const DialogName = "QueryTheFirstPlayerOfCostXYuanDialog";

export default {
  data() {
    return {
      form: {
        amount: "",
        zoneId: 0,
      },
      entry: null,
    };
  },
  components: {},

  created() {
    this.form.zoneId = dialogutil.getData(DialogName).zoneId;
  },

  methods: {
    /**
     *
     */
    async queryTheFirstPlayerOfCostXYuan() {
      let amount = Number(this.form.amount);
      amount = String(amount * 100);
      try {
        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/queryTheFirstPlayerOfCostXYuan`,
            {
              zoneId: this.form.zoneId,
              amount: amount,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message({
            message: resData.message,
            type: "error",
          });
          return;
        }

        this.entry = resData.data.entry || null;

        if (this.entry == null) {
          this.$message({
            message: "未查询到满足条件的玩家",
            type: "info",
          });
        }

        console.log("tt:", this.entry);
      } catch (e) {}
    },

    /**
     * 跳转到玩家详情界面
     * @param {*}
     */
    toRouterPlayerInfoPage(condition, value) {
      let query = {};
      switch (condition) {
        case "uid": {
          query = { uid: value, tab: "playerList" };
          break;
        }
        case "aid": {
          query = { aid: value, tab: "playerList" };
          break;
        }
      }

      window.open(
        this.$router.resolve({
          path: "/console/player/playerlist",
          query: query,
        }).href,
        "_blank"
      );
    },

    ms2ymdhmss(ts) {
      return util.ms2datetime(ts);
    },

    onClose(done) {
      // 关闭当前对话框
      dialogutil.close(DialogName);
    },
  },
};
</script>